export const endpointData = {
    restaurantById: {
        h4Id: 'res-id',
        parameters: [{
            name: 'restaurant_id',
            description: 'Numeric ID of the restaurant to get.',
            type: 'number',
            required: "true",
            example: 4071387773960467
        }],
        method: "GET",
        title: "Restaurant By ID",
        description: "Get Single Restaurant",
        endpoint: "/restaurant/{restaurant_id}",
        exampleUrl: "/restaurant/4071387773960467",
        exampleResponse: {
            "address": {
                "streetAddress": "402 Henry St",
                "city": "Brooklyn",
                "state": "NY",
                "zip": "11201",
                "formatted": "402 Henry St Brooklyn, NY 11201"
            },
            "geo": {
                "lat": 40.688151,
                "lon": -73.997466
            },
            "restaurantName": "Chan's Golden City",
            "cuisines": ["Chinese"],
            "menus": [{
                "menuName": "Main",
                "menuSections": [{
                    "sectionName": "Appetizers",
                    "menuItems": [{
                        "name": "1. Roast Pork Egg Roll",
                        "description": "",
                        "price": 1.25
                    }, {
                        "name": "2. Shrimp Egg Roll",
                        "description": "",
                        "price": 1.25
                    }, {
                        "name": "3. Vegetable Spring Roll",
                        "description": "",
                        "price": 1.25
                    }, {
                        "name": "4. Fried Wonton",
                        "description": "",
                        "price": 3.5
                    }, {
                        "name": "5. Pan Fried Wonton",
                        "description": "",
                        "price": 4
                    }, {
                        "name": "6. Szechuan Wonton *",
                        "description": "with hot sesame sauce",
                        "price": 4
                    }, {
                        "name": "7. Pan Fried Wonton *",
                        "description": "with garlic sauce",
                        "price": 4
                    }, {
                        "name": "8. Steamed Dumpling",
                        "description": "with meat",
                        "price": 4.75
                    }, {
                        "name": "9. Fried Dumpling",
                        "description": "with meat",
                        "price": 4.75
                    }, {
                        "name": "10. Steamed Veg. Dumpling",
                        "description": "",
                        "price": 4.75
                    }, {
                        "name": "11. Fried Veg. Dumpling",
                        "description": "",
                        "price": 4.75
                    }, {
                        "name": "12. Steamed Seafood Dumpling",
                        "description": "",
                        "price": 4.95
                    }, {
                        "name": "13. Boneless Spare Ribs",
                        "description": "",
                        "price": 5.5
                    }, {
                        "name": "14. Bar-B-Q Spare Ribs",
                        "description": "",
                        "price": 5.5
                    }, {
                        "name": "16. Cold Sesame Noodle",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "17. French Fries",
                        "description": "",
                        "price": 1.75
                    }, {
                        "name": "18. Fried Onion Rings",
                        "description": "",
                        "price": 1.5
                    }, {
                        "name": "19a. Crab Rangoon",
                        "description": "cheese wonton 8",
                        "price": 3.5
                    }]
                }, {
                    "sectionName": "Soup",
                    "menuItems": [{
                        "name": "19. Wonton Soup",
                        "description": "",
                        "price": 1.5
                    }, {
                        "name": "20. Wonton Egg Drop Soup",
                        "description": "",
                        "price": 1.95
                    }, {
                        "name": "21. Egg Drop Soup",
                        "description": "",
                        "price": 1.5
                    }, {
                        "name": "22. Chicken Noodle Soup",
                        "description": "",
                        "price": 1.5
                    }, {
                        "name": "23. Chicken Rice Soup",
                        "description": "",
                        "price": 1.5
                    }, {
                        "name": "24. Hot & Sour Soup *",
                        "description": "",
                        "price": 2
                    }, {
                        "name": "25. Vegetable",
                        "description": "with bean curd soup",
                        "price": 2
                    }, {
                        "name": "26. House Special Soup",
                        "description": "",
                        "price": 6.25
                    }, {
                        "name": "27. Seafood Soup",
                        "description": "",
                        "price": 7.9
                    }, {
                        "name": "28. Vegetable Yat Gaw Mein",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "29. Chicken Or Pork Yat Gaw Mein",
                        "description": "",
                        "price": 4.75
                    }, {
                        "name": "30. Beef Or Shrimp Yat Gaw Mein",
                        "description": "",
                        "price": 4.95
                    }]
                }, {
                    "sectionName": "Chow Mein Or Chop Suey",
                    "menuItems": [{
                        "name": "31. Veg",
                        "description": "",
                        "price": 4
                    }, {
                        "name": "32. Chicken",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "33. Roast Pork",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "34. Beef",
                        "description": "",
                        "price": 4.5
                    }, {
                        "name": "35. Shrimp",
                        "description": "",
                        "price": 4.5
                    }, {
                        "name": "36. House Special",
                        "description": "",
                        "price": 4.95
                    }]
                }, {
                    "sectionName": "Fried Rice",
                    "menuItems": [{
                        "name": "37. Plain",
                        "description": "",
                        "price": 3
                    }, {
                        "name": "38. Vegetable",
                        "description": "",
                        "price": 3.25
                    }, {
                        "name": "39. Roast Pork",
                        "description": "",
                        "price": 4
                    }, {
                        "name": "40. Chicken",
                        "description": "",
                        "price": 4
                    }, {
                        "name": "41. Beef",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "42. Shrimp",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "43. House Special",
                        "description": "",
                        "price": 4.75
                    }]
                }, {
                    "sectionName": "Lo Mein",
                    "menuItems": [{
                        "name": "44. Vegetable",
                        "description": "",
                        "price": 4
                    }, {
                        "name": "45. Roast Pork",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "46. Chicken",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "47. Beef",
                        "description": "",
                        "price": 4.5
                    }, {
                        "name": "48. Shrimp",
                        "description": "",
                        "price": 4.5
                    }, {
                        "name": "49. House Special",
                        "description": "",
                        "price": 5
                    }]
                }, {
                    "sectionName": "Chow Fun Or Mei Fun",
                    "menuItems": [{
                        "name": "50. Vegetable",
                        "description": "",
                        "price": 5.75
                    }, {
                        "name": "51. Chicken",
                        "description": "",
                        "price": 6.95
                    }, {
                        "name": "52. Roast Pork",
                        "description": "",
                        "price": 6.95
                    }, {
                        "name": "53. Beef",
                        "description": "",
                        "price": 7.75
                    }, {
                        "name": "54. Shrimp",
                        "description": "",
                        "price": 7.75
                    }, {
                        "name": "55. House Special",
                        "description": "",
                        "price": 7.95
                    }, {
                        "name": "56. Singapore",
                        "description": "",
                        "price": 7.95
                    }]
                }, {
                    "sectionName": "Egg Foo Young",
                    "menuItems": [{
                        "name": "57. Vegetable",
                        "description": "",
                        "price": 5.95
                    }, {
                        "name": "58. Mushroom",
                        "description": "",
                        "price": 5.95
                    }, {
                        "name": "59. Roast Pork",
                        "description": "",
                        "price": 6.25
                    }, {
                        "name": "60. Chicken",
                        "description": "",
                        "price": 6.25
                    }, {
                        "name": "61. Beef",
                        "description": "",
                        "price": 6.75
                    }, {
                        "name": "62. Shrimp",
                        "description": "",
                        "price": 6.75
                    }, {
                        "name": "63. House Special",
                        "description": "",
                        "price": 7.5
                    }]
                }, {
                    "sectionName": "Diet Dishes",
                    "menuItems": [{
                        "name": "64. Steamed Broccoli",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "65. Steamed Mixed Vegetable",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "66. Steamed Broccoli & Bean Curd",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "67. Steamed Mixed Veg. & Bean Curd",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "68. Steamed String Bean",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "69. Steamed Chicken",
                        "description": "with broccoli",
                        "price": 5.5
                    }, {
                        "name": "70. Steamed Chicken",
                        "description": "with mixed veg",
                        "price": 5.5
                    }, {
                        "name": "71. Steamed Shrimp",
                        "description": "with mixed veg",
                        "price": 5.95
                    }, {
                        "name": "72. Steamed Beef",
                        "description": "with mixed veg",
                        "price": 5.5
                    }, {
                        "name": "73. Steamed Chicken",
                        "description": "with tomato",
                        "price": 5.5
                    }, {
                        "name": "74. Steamed Chicken",
                        "description": "with snow peas",
                        "price": 5.5
                    }, {
                        "name": "75. Steamed White Meat Chicken",
                        "description": "",
                        "price": 12.5
                    }]
                }, {
                    "sectionName": "Chicken",
                    "menuItems": [{
                        "name": "76. Chicken",
                        "description": "with broccoli",
                        "price": 0
                    }, {
                        "name": "77. Chicken",
                        "description": "with mixed vegetable",
                        "price": 0
                    }, {
                        "name": "78. Chicken",
                        "description": "with string bean",
                        "price": 0
                    }, {
                        "name": "79. Chicken",
                        "description": "with bean sprouts",
                        "price": 0
                    }, {
                        "name": "80. Chicken",
                        "description": "with cashew nuts",
                        "price": 0
                    }, {
                        "name": "81. Chicken",
                        "description": "with snow peas",
                        "price": 0
                    }, {
                        "name": "82. Chicken",
                        "description": "with mushrooms",
                        "price": 0
                    }, {
                        "name": "83. Chicken",
                        "description": "with oyster sauce",
                        "price": 0
                    }, {
                        "name": "84. Chicken",
                        "description": "with chinese veg",
                        "price": 0
                    }, {
                        "name": "85. Chicken",
                        "description": "with black bean sauce",
                        "price": 0
                    }, {
                        "name": "86. Chicken",
                        "description": "with pepper & tomato",
                        "price": 0
                    }, {
                        "name": "87. Sweet & Sour Chicken",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "88. Chicken",
                        "description": "with brown sauce",
                        "price": 11.95
                    }, {
                        "name": "89. Curry Chicken *",
                        "description": "with onion",
                        "price": 0
                    }, {
                        "name": "90. Chicken *",
                        "description": "with broccoli in garlic sauce",
                        "price": 0
                    }, {
                        "name": "91. Szechuan Chicken *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "92. Hunan Chicken *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "93. Chicken *",
                        "description": "with garlic sauce",
                        "price": 0
                    }, {
                        "name": "94. Chicken Eggplant In Garlic Sauce *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "95. Chicken",
                        "description": "with spinach",
                        "price": 8.95
                    }, {
                        "name": "96. Chicken",
                        "description": "with baby bok choy",
                        "price": 8.95
                    }, {
                        "name": "97. Chicken",
                        "description": "with chinese broccoli",
                        "price": 8.95
                    }]
                }, {
                    "sectionName": "Pork",
                    "menuItems": [{
                        "name": "98. Roast Pork",
                        "description": "with broccoli",
                        "price": 0
                    }, {
                        "name": "99. Roast Pork",
                        "description": "with mixed vegetable",
                        "price": 0
                    }, {
                        "name": "100. Roast Pork",
                        "description": "with string bean",
                        "price": 0
                    }, {
                        "name": "101. Roast Pork",
                        "description": "with snow peas",
                        "price": 0
                    }, {
                        "name": "102. Roast Pork",
                        "description": "with black bean sauce",
                        "price": 0
                    }, {
                        "name": "103. Roast Pork",
                        "description": "with pepper & tomato",
                        "price": 0
                    }, {
                        "name": "104. Roast Pork",
                        "description": "with chinese veg",
                        "price": 0
                    }, {
                        "name": "105. Sweet & Sour Pork",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "106. Curry Roast Pork *",
                        "description": "with onion",
                        "price": 0
                    }, {
                        "name": "107. Roast Pork *",
                        "description": "with broccoli in garlic sauce",
                        "price": 0
                    }, {
                        "name": "108. Roast Pork Szechuan Style *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "109. Roast Pork Hunan Style *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "110. Roast Pork *",
                        "description": "with garlic sauce",
                        "price": 0
                    }, {
                        "name": "111. Hot & Spicy Shredded Pork *",
                        "description": "",
                        "price": 0
                    }]
                }, {
                    "sectionName": "Beef",
                    "menuItems": [{
                        "name": "112. Beef",
                        "description": "with broccoli",
                        "price": 0
                    }, {
                        "name": "113. Beef",
                        "description": "with mixed vegetable",
                        "price": 0
                    }, {
                        "name": "114. Beef",
                        "description": "with string bean",
                        "price": 0
                    }, {
                        "name": "115. Beef",
                        "description": "with sow peas",
                        "price": 0
                    }, {
                        "name": "116. Beef",
                        "description": "with mushroom",
                        "price": 0
                    }, {
                        "name": "117. Beef",
                        "description": "with oyster sauce",
                        "price": 0
                    }, {
                        "name": "118. Beef",
                        "description": "with black bean sauce",
                        "price": 0
                    }, {
                        "name": "119. Beef",
                        "description": "with chinese vegetable",
                        "price": 0
                    }, {
                        "name": "120. Beef",
                        "description": "with pepper & tomato",
                        "price": 0
                    }, {
                        "name": "121. Pepper Steak",
                        "description": "with onion",
                        "price": 0
                    }, {
                        "name": "122. Curry Beef *",
                        "description": "with onion",
                        "price": 0
                    }, {
                        "name": "123. Beef *",
                        "description": "with broccoli in garlic sauce",
                        "price": 0
                    }, {
                        "name": "124. Szechuan Beef *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "125. Hunan Beef *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "126. Beef *",
                        "description": "with garlic sauce",
                        "price": 0
                    }, {
                        "name": "127. Hot & Spicy Shredded Beef *",
                        "description": "",
                        "price": 0
                    }]
                }, {
                    "sectionName": "Moo Shu Dishes",
                    "menuItems": [{
                        "name": "128. Moo Shu Vegetable",
                        "description": "",
                        "price": 7.25
                    }, {
                        "name": "129. Moo Shu Pork",
                        "description": "",
                        "price": 8.75
                    }, {
                        "name": "130. Moo Shu Chicken",
                        "description": "",
                        "price": 8.75
                    }, {
                        "name": "131. Mooshu Beef",
                        "description": "",
                        "price": 8.95
                    }, {
                        "name": "132. Moo Shu Shrimp",
                        "description": "",
                        "price": 8.95
                    }]
                }, {
                    "sectionName": "Vegetable",
                    "menuItems": [{
                        "name": "133. Sauteed Bean Sprouts",
                        "description": "",
                        "price": 3.75
                    }, {
                        "name": "134. Sauteed Broccoli",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "135 Sauteed String Bean",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "136. Sauteed Mixed Vegetable",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "137. Sauteed Double Mushroom",
                        "description": "",
                        "price": 4.5
                    }, {
                        "name": "138. Mixed Vegs. In Garlic Sauce *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "139. Broccoli In Garlic Sauce *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "140. String Bean In Garlic Sauce *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "141. Eggplant In Garlic Sauce *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "142. String Bean Szechuan Sauce *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "143. Sauteed Chinese Broccoli",
                        "description": "",
                        "price": 8.25
                    }, {
                        "name": "144. Sauteed Chinese Broccoli",
                        "description": "with bean curd",
                        "price": 8.25
                    }, {
                        "name": "145. Sauteed Baby Bok Choy",
                        "description": "",
                        "price": 8.25
                    }, {
                        "name": "146. Sauteed Spinach",
                        "description": "",
                        "price": 8.25
                    }, {
                        "name": "147. Sauteed Spinach",
                        "description": "with bean curd",
                        "price": 8.25
                    }]
                }, {
                    "sectionName": "Seafood",
                    "menuItems": [{
                        "name": "148. Shrimp",
                        "description": "with broccoli",
                        "price": 0
                    }, {
                        "name": "149. Shrimp",
                        "description": "with mixed vegetable",
                        "price": 0
                    }, {
                        "name": "150. Shrimp",
                        "description": "with snow peas",
                        "price": 0
                    }, {
                        "name": "151. Shrimp",
                        "description": "with lobster sauce",
                        "price": 0
                    }, {
                        "name": "152. Shrimp",
                        "description": "with mushroom",
                        "price": 0
                    }, {
                        "name": "153. Shrimp",
                        "description": "with oyster sauce",
                        "price": 0
                    }, {
                        "name": "154. Shrimp",
                        "description": "with pepper & tomato",
                        "price": 0
                    }, {
                        "name": "155. Shrimp",
                        "description": "with black bean sauce",
                        "price": 0
                    }, {
                        "name": "156. Shrimp",
                        "description": "with chinese vegetable",
                        "price": 0
                    }, {
                        "name": "157. Shrimp",
                        "description": "with cashew nuts",
                        "price": 0
                    }, {
                        "name": "158. Shrimp",
                        "description": "with bean sprouts",
                        "price": 0
                    }, {
                        "name": "159. Plain Lobster Sauce",
                        "description": "",
                        "price": 3.5
                    }, {
                        "name": "160. Shrimp",
                        "description": "with string bean",
                        "price": 0
                    }, {
                        "name": "161. Curry Shrimp *",
                        "description": "with onion",
                        "price": 0
                    }, {
                        "name": "162. Shrimp *",
                        "description": "with broccoli in garlic sauce",
                        "price": 0
                    }, {
                        "name": "163. Szechuan Shrimp *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "164. Hunan Shrimp *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "165. Shrimp *",
                        "description": "with garlic sauce",
                        "price": 0
                    }, {
                        "name": "166. Shrimp *",
                        "description": "with eggplant in garlic sauce",
                        "price": 5.5
                    }, {
                        "name": "167. Shrimp",
                        "description": "with spinach",
                        "price": 9.75
                    }, {
                        "name": "168. Shrimp",
                        "description": "with baby bok choy",
                        "price": 9.75
                    }, {
                        "name": "169. Shrimp",
                        "description": "with chinese broccoli",
                        "price": 9.75
                    }]
                }, {
                    "sectionName": "Bean Curd",
                    "menuItems": [{
                        "name": "170. Broccoli",
                        "description": "with bean curd",
                        "price": 4.25
                    }, {
                        "name": "171. Mixed Veg",
                        "description": "with bean curd",
                        "price": 4.25
                    }, {
                        "name": "172. Mushroom",
                        "description": "with bean curd",
                        "price": 4.25
                    }, {
                        "name": "173. Double Mushroom",
                        "description": "with bean curd",
                        "price": 4.5
                    }, {
                        "name": "174. Bean Curd",
                        "description": "with mixed veg in black bean sauce",
                        "price": 4.25
                    }, {
                        "name": "175. Beef",
                        "description": "with bean curd",
                        "price": 5.5
                    }, {
                        "name": "176. Chicken",
                        "description": "with bean curd",
                        "price": 5.5
                    }, {
                        "name": "177. Shrimp",
                        "description": "with bean curd",
                        "price": 5.95
                    }, {
                        "name": "178. Broccoli Bean Curd In Garlic Sauce *",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "179. Bean Curd *",
                        "description": "with mixed veg in garlic sauce",
                        "price": 4.25
                    }, {
                        "name": "180. Home Made Bean Curd *",
                        "description": "with meat",
                        "price": 5.25
                    }, {
                        "name": "181. Bean Curd Szechuan Style *",
                        "description": "",
                        "price": 4.25
                    }, {
                        "name": "182. Curry Bean Curd *",
                        "description": "with onions",
                        "price": 4.25
                    }, {
                        "name": "183. Kung Po Bean Curd *",
                        "description": "",
                        "price": 7.75
                    }, {
                        "name": "184. General Tso's Bean Curd *",
                        "description": "",
                        "price": 7.75
                    }, {
                        "name": "185. Orange Flavor Bean Curd *",
                        "description": "",
                        "price": 7.75
                    }, {
                        "name": "186. Sesame Bean Curd",
                        "description": "",
                        "price": 7.75
                    }]
                }, {
                    "sectionName": "Vegetarian Meat $9.50",
                    "menuItems": [{
                        "name": "V1. Sesame Veg Chicken",
                        "description": "crispy chunks of veg chicken with snow pea, broccoli, black mushroom, carrots, bamboo shoots and waterchestnuts in special sauce",
                        "price": 0
                    }, {
                        "name": "V2. General Tso's Veg Chicken *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "V3. Orange Flavored Veg Chicken *",
                        "description": "",
                        "price": 0
                    }]
                }, {
                    "sectionName": "Side Order",
                    "menuItems": [{
                        "name": "Fortune Cookies",
                        "description": "",
                        "price": 0.3
                    }, {
                        "name": "Boiled Rice",
                        "description": "",
                        "price": 1.25
                    }, {
                        "name": "Homemade Crispy Noodle",
                        "description": "",
                        "price": 0.3
                    }, {
                        "name": "Brown Rice",
                        "description": "",
                        "price": 1.5
                    }, {
                        "name": "Homemade Ice Tea",
                        "description": "",
                        "price": 1.5
                    }]
                }, {
                    "sectionName": "All Day Special",
                    "menuItems": [{
                        "name": "A1. General Tso's Chicken *",
                        "description": "",
                        "price": 5.95
                    }, {
                        "name": "A2. General Tso's Bean Curd *",
                        "description": "",
                        "price": 5.25
                    }, {
                        "name": "A3. Szechuan Chicken & Shrimp *",
                        "description": "",
                        "price": 5.95
                    }, {
                        "name": "A4. Hunan Chicken & Shrimp *",
                        "description": "",
                        "price": 5.95
                    }, {
                        "name": "A5. Chicken & Shrimp In Garlic Sauce *",
                        "description": "",
                        "price": 5.95
                    }, {
                        "name": "A6. Sesame Chicken",
                        "description": "",
                        "price": 5.95
                    }, {
                        "name": "A7. Sesame Bean Curd",
                        "description": "",
                        "price": 5.25
                    }, {
                        "name": "A8. Shrimp Bean Curd & Black Mushroom",
                        "description": "",
                        "price": 5.95
                    }, {
                        "name": "A9. Happy Family",
                        "description": "",
                        "price": 6.75
                    }, {
                        "name": "A10. Boneless Spare Ribs",
                        "description": "",
                        "price": 5.95
                    }]
                }, {
                    "sectionName": "Special",
                    "menuItems": [{
                        "name": "S1. Fried Half Chicken",
                        "description": "plain",
                        "price": 3.75
                    }, {
                        "name": "S1. Fried Half Chicken",
                        "description": "french fries or fried rice",
                        "price": 4.75
                    }, {
                        "name": "S1. Fried Half Chicken",
                        "description": "with chicken or pork fried rice",
                        "price": 5
                    }, {
                        "name": "S1. Fried Half Chicken",
                        "description": "with beef or shrimp fried rice",
                        "price": 5.5
                    }, {
                        "name": "S2. Fried Chicken Wings (4)",
                        "description": "plain",
                        "price": 3.5
                    }, {
                        "name": "S2. Fried Chicken Wings (4)",
                        "description": "french fries or fried rice",
                        "price": 4.5
                    }, {
                        "name": "S2. Fried Chicken Wings (4)",
                        "description": "with chicken or pork fried rice",
                        "price": 4.75
                    }, {
                        "name": "S2. Fried Chicken Wings (4)",
                        "description": "with beef or shrimp fried rice",
                        "price": 5.25
                    }, {
                        "name": "S3. Fried Fish",
                        "description": "plain",
                        "price": 3.75
                    }, {
                        "name": "S3. Fried Fish",
                        "description": "french fries or fried rice",
                        "price": 4.75
                    }, {
                        "name": "S3. Fried Fish",
                        "description": "with chicken or pork fried rice",
                        "price": 5
                    }, {
                        "name": "S3. Fried Fish",
                        "description": "with beef or shrimp fried rice",
                        "price": 5.25
                    }, {
                        "name": "S4. Fried Jumbo Shrimp (5)",
                        "description": "plain",
                        "price": 4.25
                    }, {
                        "name": "S4. Fried Jumbo Shrimp (5)",
                        "description": "french fries or fried rice",
                        "price": 5.25
                    }, {
                        "name": "S4. Fried Jumbo Shrimp (5)",
                        "description": "with chicken or pork fried rice",
                        "price": 5.75
                    }, {
                        "name": "S4. Fried Jumbo Shrimp (5)",
                        "description": "with beef or shrimp fried rice",
                        "price": 6.25
                    }, {
                        "name": "S5. Fried Shrimp Basket (16)",
                        "description": "plain",
                        "price": 4.25
                    }, {
                        "name": "S5. Fried Shrimp Basket (16)",
                        "description": "french fries or fried rice",
                        "price": 5.25
                    }, {
                        "name": "S5. Fried Shrimp Basket (16)",
                        "description": "with chicken or pork fried rice",
                        "price": 5.75
                    }, {
                        "name": "S5. Fried Shrimp Basket (16)",
                        "description": "with beef or shrimp fried rice",
                        "price": 6.25
                    }, {
                        "name": "S6. Fried Chicken Nuggets (10)",
                        "description": "plain",
                        "price": 3.75
                    }, {
                        "name": "S6. Fried Chicken Nuggets (10)",
                        "description": "french fries or fried rice",
                        "price": 4.75
                    }, {
                        "name": "S6. Fried Chicken Nuggets (10)",
                        "description": "with chicken or pork fried rice",
                        "price": 5
                    }, {
                        "name": "S6. Fried Chicken Nuggets (10)",
                        "description": "with beef or shrimp fried rice",
                        "price": 5.5
                    }, {
                        "name": "S7. Half Chicken With Garlic Sauce*",
                        "description": "plain",
                        "price": 4.75
                    }, {
                        "name": "S7. Half Chicken With Garlic Sauce*",
                        "description": "french fries or fried rice",
                        "price": 5.75
                    }, {
                        "name": "S7. Half Chicken With Garlic Sauce*",
                        "description": "with chicken or pork fried rice",
                        "price": 6
                    }, {
                        "name": "S7. Half Chicken With Garlic Sauce*",
                        "description": "with beef or shrimp fried rice",
                        "price": 6.5
                    }, {
                        "name": "S8. Chicken Wing With Garlic Sauce*",
                        "description": "plain",
                        "price": 4.5
                    }, {
                        "name": "S8. Chicken Wing With Garlic Sauce*",
                        "description": "french fries or fried rice",
                        "price": 5.5
                    }, {
                        "name": "S8. Chicken Wing With Garlic Sauce*",
                        "description": "with chicken or pork fried rice",
                        "price": 5.75
                    }, {
                        "name": "S8. Chicken Wing With Garlic Sauce*",
                        "description": "with beef or shrimp fried rice",
                        "price": 6.25
                    }, {
                        "name": "S9. Honey Chicken Wings",
                        "description": "plain",
                        "price": 4.5
                    }, {
                        "name": "S9. Honey Chicken Wings",
                        "description": "french fries or fried rice",
                        "price": 5.5
                    }, {
                        "name": "S9. Honey Chicken Wings",
                        "description": "with chicken or pork fried rice",
                        "price": 5.75
                    }, {
                        "name": "S9. Honey Chicken Wings",
                        "description": "with beef or shrimp fried rice",
                        "price": 6.25
                    }, {
                        "name": "S10. Bar-B-Q Chicken Wings",
                        "description": "plain",
                        "price": 4.5
                    }, {
                        "name": "S10. Bar-B-Q Chicken Wings",
                        "description": "french fries or fried rice",
                        "price": 5.5
                    }, {
                        "name": "S10. Bar-B-Q Chicken Wings",
                        "description": "with chicken or pork fried rice",
                        "price": 5.75
                    }, {
                        "name": "S10. Bar-B-Q Chicken Wings",
                        "description": "with beef or shrimp fried rice",
                        "price": 6.25
                    }, {
                        "name": "S11. Sesame Chicken Wings",
                        "description": "plain",
                        "price": 4.5
                    }, {
                        "name": "S11. Sesame Chicken Wings",
                        "description": "french fries or fried rice",
                        "price": 5.5
                    }, {
                        "name": "S11. Sesame Chicken Wings",
                        "description": "with chicken or pork fried rice",
                        "price": 5.75
                    }, {
                        "name": "S11. Sesame Chicken Wings",
                        "description": "with beef or shrimp fried rice",
                        "price": 6.25
                    }, {
                        "name": "S12. Spicy Chicken Wings *",
                        "description": "plain",
                        "price": 4.5
                    }, {
                        "name": "S12. Spicy Chicken Wings *",
                        "description": "french fries or fried rice",
                        "price": 5.5
                    }, {
                        "name": "S12. Spicy Chicken Wings *",
                        "description": "with chicken or pork fried rice",
                        "price": 5.75
                    }, {
                        "name": "S12. Spicy Chicken Wings *",
                        "description": "with beef or shrimp fried rice",
                        "price": 6.25
                    }, {
                        "name": "S13. General Tso's Chicken Wings *",
                        "description": "plain",
                        "price": 4.5
                    }, {
                        "name": "S13. General Tso's Chicken Wings *",
                        "description": "french fries or fried rice",
                        "price": 5.5
                    }, {
                        "name": "S13. General Tso's Chicken Wings *",
                        "description": "with chicken or pork fried rice",
                        "price": 5.75
                    }, {
                        "name": "S13. General Tso's Chicken Wings *",
                        "description": "with beef or shrimp fried rice",
                        "price": 6.25
                    }]
                }, {
                    "sectionName": "House Special",
                    "menuItems": [{
                        "name": "H1. Seafood Delight",
                        "description": "lobster, scallop, jumbo shrimp, imitation crab meat & mixed",
                        "price": 11.95
                    }, {
                        "name": "H2, Happy Family",
                        "description": "jumbo shrimp, lobster meat, sliced pork, beef, chicken & mixed vegetables in brown sauce.",
                        "price": 11.5
                    }, {
                        "name": "H3. Four Season",
                        "description": "a combination of sliced chicken, pork, shrimp & vegetables in house special brown sauce.",
                        "price": 10.5
                    }, {
                        "name": "H4. Tung Ting Shrimp",
                        "description": "jumbo shrimp with broccoli, mushroom, bamboo shoots & chinese vegetables in egg white sauce.",
                        "price": 9.95
                    }, {
                        "name": "H5. Green Jade Scallops",
                        "description": "fresh scallops with snow peas, mushrooms & broccoli in our special white sauce.",
                        "price": 10.5
                    }, {
                        "name": "H6. Scallops & Beef",
                        "description": "fresh scallops, sliced beef with mixed vegetable & baby corn in house special sauce.",
                        "price": 10.95
                    }, {
                        "name": "H7. Pineapple Chicken",
                        "description": "white meat chicken, pineapple, mixed vegetable cooked with our chef's special sauce.",
                        "price": 9.95
                    }, {
                        "name": "H8. Triple Crown",
                        "description": "shrimp, chicken, & beef with mixed vegetable in brown sauce.",
                        "price": 9.95
                    }, {
                        "name": "H9. Shredded Beef",
                        "description": "with scallion",
                        "price": 9.25
                    }, {
                        "name": "H10. Lemon Chicken",
                        "description": "",
                        "price": 8.75
                    }, {
                        "name": "H11. Boneless Chicken",
                        "description": "",
                        "price": 8.75
                    }, {
                        "name": "H12. Pan Fried Noodles",
                        "description": "with mixed vegs",
                        "price": 8.5
                    }, {
                        "name": "H13. Seafood Pan Fried Noodles",
                        "description": "",
                        "price": 11.95
                    }, {
                        "name": "H14. House Special Pan Fried Noodles",
                        "description": "",
                        "price": 10.5
                    }, {
                        "name": "H15. Sesame Shrimp",
                        "description": "jumbo shrimp lightly fried in sweet & lemon sauce surrounded with broccoli.",
                        "price": 10.95
                    }, {
                        "name": "H16. Sesame Chicken",
                        "description": "",
                        "price": 8.95
                    }, {
                        "name": "H17. Sesame Beef",
                        "description": "",
                        "price": 9.75
                    }, {
                        "name": "H18. General Tso's Chicken *",
                        "description": "chunks of chicken deep fried to crispy with sweet & spicy hunan sauce with broccoli.",
                        "price": 8.95
                    }, {
                        "name": "H19. General Tso's Shrimp *",
                        "description": "",
                        "price": 10.95
                    }, {
                        "name": "H20. Orange Flavored Chicken *",
                        "description": "chunks of chicken, deep fried in orange flavored sauce with broccoli.",
                        "price": 8.95
                    }, {
                        "name": "H21. Orange Flavored Beef *",
                        "description": "chunks of beef deep fried in orange flavored sauce with broccoli.",
                        "price": 9.75
                    }, {
                        "name": "H22. Szechuan Chicken & Beef *",
                        "description": "slices of chicken & beef with mixed vegetable in spicy szechuan sauce.",
                        "price": 9.95
                    }, {
                        "name": "H23. Hunan Chicken & Beef *",
                        "description": "slices of tender chicken & beef combined with vegetables in spicy brown sauce.",
                        "price": 9.95
                    }, {
                        "name": "H24. Shrimp Beef & Chicken In Garlic Sauce *",
                        "description": "shrimp, beef & chicken with mixed vegetables in special hot garlic sauce.",
                        "price": 9.95
                    }, {
                        "name": "H25. Kung Po Chicken *",
                        "description": "chicken with peanuts, bamboo shoots, waterchestnuts, celery & carrots with spicy sauce.",
                        "price": 8.95
                    }, {
                        "name": "H26. Kung Po Shrimp *",
                        "description": "",
                        "price": 9.75
                    }]
                }, {
                    "sectionName": "Special",
                    "menuItems": [{
                        "name": "LC 1. General Tso's Chicken *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 2. Orange Flavored Chicken *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 3. Szechuan Chicken & Beef *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 4. Hunan Chicken & Beef *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 5. Beef & Chicken In Garlic Sauce *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 6. Sesame Chicken",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 7. House Special Lo Mein",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 8. Boneless Spare Ribs",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 9. Bar-B-Q Spare Ribs",
                        "description": "",
                        "price": 7.15
                    }, {
                        "name": "LC 10. Diced Chicken & Shrimp",
                        "description": "",
                        "price": 0
                    }]
                }, {
                    "sectionName": "Chicken Or Roast Pork Or Beef",
                    "menuItems": [{
                        "name": "LC 11. Chicken, Pork Or Beef",
                        "description": "with broccoli",
                        "price": 0
                    }, {
                        "name": "LC 12. Chicken, Pork Or Beef",
                        "description": "with mixed veg.",
                        "price": 0
                    }, {
                        "name": "LC 13. Chicken, Pork Or Beef",
                        "description": "with string beans",
                        "price": 0
                    }, {
                        "name": "LC 14. Chicken Or Beef",
                        "description": "with snow peas",
                        "price": 0
                    }, {
                        "name": "LC 15. Chicken, Pork Or Beef",
                        "description": "with mushroom",
                        "price": 0
                    }, {
                        "name": "LC 16. Chicken, Beef",
                        "description": "with black bean sauce",
                        "price": 0
                    }, {
                        "name": "LC 17. Chicken",
                        "description": "with chinese vegetables",
                        "price": 0
                    }, {
                        "name": "LC 18. Chicken, Pork Or Beef",
                        "description": "with pepper & tomato",
                        "price": 0
                    }, {
                        "name": "LC 19. Chicken, Pork Or Beef Lo Mein",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 20. Chicken, Pork Or Beef Egg Foo Young",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 21. Chicken",
                        "description": "with cashew nuts",
                        "price": 0
                    }, {
                        "name": "LC 22. Pepper Steak",
                        "description": "with onion",
                        "price": 0
                    }, {
                        "name": "LC 23. Sweet & Sour Chicken Or Pork",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 24. Curry Chicken Or Beef *",
                        "description": "with onion",
                        "price": 0
                    }, {
                        "name": "LC 25. Szechuan Chicken Or Pork Beef *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 26. Hunan Chicken, Pork Or Beef *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 27. Chicken, Pork Or Beef *",
                        "description": "with garlic sauce",
                        "price": 0
                    }, {
                        "name": "LC 28. Chicken Eggplant In Garlic Sauce *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 29. Hot & Spicy Shredded Chicken, Pork Or Beef *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 30. Kung Po Chicken *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 31. Chicken, Pork Or Beef Broccoli In Garlic Sauce *",
                        "description": "",
                        "price": 0
                    }]
                }, {
                    "sectionName": "Seafood",
                    "menuItems": [{
                        "name": "LC 32. Shrimp",
                        "description": "with broccoli",
                        "price": 0
                    }, {
                        "name": "LC 33. Shrimp",
                        "description": "with mixed vegetable",
                        "price": 0
                    }, {
                        "name": "LC 34. Shrimp",
                        "description": "with snow peas",
                        "price": 0
                    }, {
                        "name": "LC 35. Shrimp",
                        "description": "with lobster sauce",
                        "price": 0
                    }, {
                        "name": "LC 36. Shrimp",
                        "description": "with chinese vegetable",
                        "price": 0
                    }, {
                        "name": "LC 37. Shrimp Lo Mein",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 38. Shrimp Egg Foo Young",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 39. Curry Shrimp *",
                        "description": "with onion",
                        "price": 0
                    }, {
                        "name": "LC 40. Szechuan Shrimp *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 41. Hunan Shrimp *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 42. Shrimp *",
                        "description": "with garlic sauce",
                        "price": 0
                    }, {
                        "name": "LC 43. Shrimp *",
                        "description": "with broccoli in garlic sauce",
                        "price": 0
                    }]
                }, {
                    "sectionName": "Vegetables",
                    "menuItems": [{
                        "name": "LC 43. Sesame Bean Curd",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 44. Sauteed Broccoli",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 45. Sauteed String Bean",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 46. Sauteed Mixed Vegetables",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 47. Vegetable Lo Mein",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 48. Mixed Vegs",
                        "description": "with bean curd",
                        "price": 0
                    }, {
                        "name": "LC 49. Broccoli In Garlic Sauce *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 50. String Bean In Garlic Sauce *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 51. Eggplant In Garlic Sauce *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 52. Broccoli Bean Curd In Garlic Sauce *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 53. Bean Curd Szechuan Style *",
                        "description": "",
                        "price": 0
                    }, {
                        "name": "LC 54. General Tso's Bean Curd *",
                        "description": "",
                        "price": 0
                    }]
                }]
            }],
            "priceRange": "$$",
            "priceRangeNum": 2,
            "hours": "Mon-Thu: 11am-11pm Fri-Sat: 11am-11:30am Sun: 12pm-11pm",
            "restaurant_phone": "(718) 625-8583",
            "restaurant_website": "",
            "restaurant_id": 4068815173997466
        }
    },
    restaurantSearchGeo: {
        h4Id: 'res-search-geo',
        parameters: [{
                name: 'lat',
                description: 'Latitude of search area',
                type: 'number',
                required: "true",
                example: 40.68919,
                default: ''
            },
            {
                name: 'lon',
                description: 'Longitude of search area',
                type: 'number',
                required: "true",
                example: -73.992378,
                default: ''
            },
            {
                name: 'distance',
                description: 'Search Area radius (in miles)',
                type: 'number',
                required: "true",
                example: 5,
                default: ''
            },
            {
                name: 'page',
                description: 'Page Through Results',
                type: 'number',
                required: "false",
                example: '1',
                default: '1'
            },
            {
                name: 'size',
                description: '# Of Results',
                type: 'number',
                required: "false",
                example: '10',
                default: '25 or 10'
            },
            {
                name: 'fullmenu',
                description: 'include full menus (or not)',
                type: 'Boolean',
                required: "false",
                example: 'false',
                default: 'false'
            }
        ],
        method: "GET",
        title: "Search Restaurants By Geo Location",
        description: "Search Function using location and search radius. Returns list of restaurants sorted by closest",
        endpoint: "/restaurants/search/geo",
        exampleUrl: '/restaurants/search/geo?lat=40.688072&lon=-73.997385&distance=1',
        exampleResponse: {
            "totalResults": 771,
            "page": 1,
            "total_pages": 386,
            "more_pages": true,
            "data": [{
                "address": {
                    "streetAddress": "391 Henry St",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "formatted": "391 Henry St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.688072,
                    "lon": -73.997385
                },
                "restaurantName": "Bocca Lupo",
                "cuisines": ["Alcohol", "Italian", "Tapas"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "Mon-Thu: 11:30am-12am Fri: 11:30am-2am Sat: 10:30am-2am Sun: 10:30am-12am",
                "restaurant_phone": "(718) 243-2522",
                "restaurant_website": "",
                "restaurant_id": 4068807273997385
            }, {
                "address": {
                    "streetAddress": "402 Henry St",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "formatted": "402 Henry St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.688151,
                    "lon": -73.997466
                },
                "restaurantName": "Chan's Golden City",
                "cuisines": ["Chinese"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Mon-Thu: 11am-11pm Fri-Sat: 11am-11:30am Sun: 12pm-11pm",
                "restaurant_phone": "(718) 625-8583",
                "restaurant_website": "",
                "restaurant_id": 4068815173997466
            }],
            "numResults": 2
        }
    },
    restaurantSearchGeoBox: {
        h4Id: 'res-search-geo-box',
        parameters: [{
                name: 'top_left',
                description: 'Top Left coordinates of Bounding Box in lat,lon',
                type: 'string',
                required: "true",
                example: '40.7636412,-74.016265',
                default: ''
            },
            {
                name: 'bottom_right',
                description: 'Bottom Right coordinates of Bounding Box in lat,lon',
                type: 'string',
                required: "true",
                example: '40.706929,-73.96682',
                default: ''
            },
            {
                name: 'page',
                description: 'Page Through Results',
                type: 'number',
                required: "false",
                example: '1',
                default: '1'
            },
            {
                name: 'size',
                description: '# Of Results',
                type: 'number',
                required: "false",
                example: '10',
                default: '25 or 10'
            },
            {
                name: 'fullmenu',
                description: 'include full menus (or not)',
                type: 'Boolean',
                required: "false",
                example: 'false',
                default: 'false'
            }
        ],
        method: "GET",
        title: "Restaurants In Geo Bounding Box",
        description: "Search Function using Geobounding Box. Returns list of restaurants inside GeoBounding Box.",
        endpoint: "/restaurants/geobbox",
        exampleUrl: '/api/restaurants/geobbox?top_left=40.7636412,-74.016265&bottom_right=40.706929,-73.96682',
        exampleResponse: {
            "totalResults": 9525,
            "page": 1,
            "total_pages": 382,
            "more_pages": true,
            "data": [{
                "address": {
                    "streetAddress": "198 Madison Ave",
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "restaurantName": "Cafe 35",
                "cuisines": [""],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "",
                "restaurant_phone": "(718) 578-9926",
                "restaurant_website": "",
                "restaurant_id": 4074837073982692
            }, {
                "address": {
                    "streetAddress": "73 Chrystie St",
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10002",
                    "formatted": "73 Chrystie St Manhattan, NY 10002"
                },
                "geo": {
                    "lat": 40.717119,
                    "lon": -73.994562
                },
                "restaurantName": "Kung Fu Tea",
                "cuisines": ["Chinese", "Coffee & Tea", "Teahouses"],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "",
                "restaurant_phone": "(646) 288-4936",
                "restaurant_website": "https://kungfutea.com",
                "restaurant_id": 4071711973994562
            }, {
                "address": {
                    "streetAddress": "447 3rd Ave",
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "formatted": "447 3rd Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.745309,
                    "lon": -73.978425
                },
                "restaurantName": "Ethos Taverna",
                "cuisines": ["Greek"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "Sun-Thu: 11:30am-11pm Fri-Sat: 11:30am-12am",
                "restaurant_phone": "(212) 252-1972",
                "restaurant_website": "",
                "restaurant_id": 4074530973978425
            }, {
                "address": {
                    "streetAddress": "11 W 32nd Street",
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10001",
                    "formatted": "11 W 32nd Street Manhattan, NY 10001"
                },
                "geo": {
                    "lat": 40.747788,
                    "lon": -73.986274
                },
                "restaurantName": "Kung Fu Tea",
                "cuisines": [""],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(212) 695-5888",
                "restaurant_website": "https://kungfutea.com",
                "restaurant_id": 4074778873986274
            }, {
                "address": {
                    "streetAddress": "916 3rd Ave",
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10022",
                    "formatted": "916 3rd Ave Manhattan, NY 10022"
                },
                "geo": {
                    "lat": 40.7592,
                    "lon": -73.9686
                },
                "restaurantName": "Dunkin'",
                "cuisines": [""],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(646) 524-5805",
                "restaurant_website": "https://www.dunkindonuts.com?utm_source=yext&utm_medium=local&utm_campaign=localmaps&utm_content=353234",
                "restaurant_id": 4075920073968600
            }, {
                "address": {
                    "streetAddress": "24 E 12th St",
                    "city": "NEW YORK",
                    "state": "NY",
                    "zip": "10003",
                    "formatted": "24 E 12th St NEW YORK, NY 10003"
                },
                "geo": {
                    "lat": 40.734109,
                    "lon": -73.993241
                },
                "restaurantName": "Stand 4",
                "cuisines": ["American", "Burgers", "Healthy", "Salads"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "Mon-Thu: 11am-11pm Fri: 11am-12am Sat: 11am-12am Sun: 11am-11pm ",
                "restaurant_phone": "(212) 488-5900",
                "restaurant_website": "",
                "restaurant_id": 4073410973993241
            }, {
                "address": {
                    "streetAddress": "502 6th Ave",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10011",
                    "formatted": "502 6th Ave New York, NY 10011"
                },
                "geo": {
                    "lat": 40.736476,
                    "lon": -73.997333
                },
                "restaurantName": "Bar Six",
                "cuisines": ["Cocktails", "French", "Moroccan"],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "Lunch Mon-Fri: 11am-4pm Dinner Sun-Thu: 5pm-1am Fri-Sat: 5pm-2am Brunch Sat-Sun: 11am-4pm",
                "restaurant_phone": "(212) 691-1363",
                "restaurant_website": "http://barsixny.com/",
                "restaurant_id": 4073647673997333
            }, {
                "address": {
                    "streetAddress": "72 University Pl",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10003",
                    "formatted": "72 University Pl New York, NY 10003"
                },
                "geo": {
                    "lat": 40.733548,
                    "lon": -73.993511
                },
                "restaurantName": "Jackson Diner",
                "cuisines": ["Indian"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "Sun-Thu: 12pm-10pm Fri-Sat: 12pm-10:30pm",
                "restaurant_phone": "(212) 620-5544",
                "restaurant_website": "",
                "restaurant_id": 4073354873993511
            }, {
                "address": {
                    "streetAddress": "12 E 12th St",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10003",
                    "formatted": "12 E 12th St New York, NY 10003"
                },
                "geo": {
                    "lat": 40.73425,
                    "lon": -73.99358
                },
                "restaurantName": "Gotham Bar & Grill",
                "cuisines": ["American (New)", "Local/Organic"],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "Lunch Mon-Fri: 12pm-2:15pm Dinner Mon-Thu: 5:30pm-10pm Fri: 5:30pm-11pm Sat: 5pm-11pm Sun: 5pm-10pm",
                "restaurant_phone": "(212) 620-4020",
                "restaurant_website": "http://www.gothambarandgrill.com",
                "restaurant_id": 4073425073993580
            }, {
                "address": {
                    "streetAddress": "13 E 12th St",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10003",
                    "formatted": "13 E 12th St New York, NY 10003"
                },
                "geo": {
                    "lat": 40.734346,
                    "lon": -73.9935
                },
                "restaurantName": "Strip House",
                "cuisines": ["Steak"],
                "menus": [],
                "priceRange": "$$$$",
                "priceRangeNum": 4,
                "hours": "Sun-Mon: 5pm-10pm Tue-Thu: 5pm-11pm Fri-Sat: 5pm-11:30pm",
                "restaurant_phone": "(212) 328-0000",
                "restaurant_website": "http://www.striphouse.net",
                "restaurant_id": 4073434673993500
            }, {
                "address": {
                    "streetAddress": "48 E 12th St",
                    "city": "NEW YORK",
                    "state": "NY",
                    "zip": "10003",
                    "formatted": "48 E 12th St NEW YORK, NY 10003"
                },
                "geo": {
                    "lat": 40.733412,
                    "lon": -73.99156
                },
                "restaurantName": "Piola",
                "cuisines": ["American", "Pizza"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "Sun-Thu: 12pm-12am Fri-Sat: 12pm-1am",
                "restaurant_phone": "(212) 777-7781",
                "restaurant_website": "http://www.piola.it",
                "restaurant_id": 4073341273991560
            }, {
                "address": {
                    "streetAddress": "90 University Pl",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10003",
                    "formatted": "90 University Pl New York, NY 10003"
                },
                "geo": {
                    "lat": 40.733803,
                    "lon": -73.993149
                },
                "restaurantName": "The Grey Dog - University",
                "cuisines": ["Coffee & Tea", "Sandwiches"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Mon: 7am - 10:30pmTues-Fri: 7am - 11:30pmSat: 7:30am - 11:30pmSun: 7:30am - 10:30pm",
                "restaurant_phone": "(212) 966-1060",
                "restaurant_website": "http://www.thegreydog.com",
                "restaurant_id": 4073380373993149
            }, {
                "address": {
                    "streetAddress": "126 W 13th St",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10011",
                    "formatted": "126 W 13th St New York, NY 10011"
                },
                "geo": {
                    "lat": 40.737178,
                    "lon": -73.998568
                },
                "restaurantName": "Gradisca",
                "cuisines": ["Italian"],
                "menus": [],
                "priceRange": "$$$$",
                "priceRangeNum": 4,
                "hours": "Sun-Thu: 5:30pm-11pm Fri-Sat: 5:30pm-11:30pm",
                "restaurant_phone": "(212) 691-4886",
                "restaurant_website": "http://www.gradiscanyc.com",
                "restaurant_id": 4073717873998568
            }, {
                "address": {
                    "streetAddress": "17 E 13th St",
                    "city": "NEW YORK",
                    "state": "NY",
                    "zip": "10003",
                    "formatted": "17 E 13th St NEW YORK, NY 10003"
                },
                "geo": {
                    "lat": 40.735042,
                    "lon": -73.992967
                },
                "restaurantName": "The Adore",
                "cuisines": ["American", "Bakery & Pastries", "Coffee & Tea"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Mon-Fri: 8am-6pm Sat: 9am-5pm",
                "restaurant_phone": "(212) 243-8742",
                "restaurant_website": "",
                "restaurant_id": 4073504273992967
            }, {
                "address": {
                    "streetAddress": "113 W 13th St",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10011",
                    "formatted": "113 W 13th St New York, NY 10011"
                },
                "geo": {
                    "lat": 40.737163,
                    "lon": -73.99786
                },
                "restaurantName": "Spain Restaurant",
                "cuisines": ["Spanish", "Tapas"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "Daily: 12pm-1am",
                "restaurant_phone": "(212) 929-9580",
                "restaurant_website": "",
                "restaurant_id": 4073716373997860
            }, {
                "address": {
                    "streetAddress": "90 University Pl",
                    "city": "NEW YORK",
                    "state": "NY",
                    "zip": "10003",
                    "formatted": "90 University Pl NEW YORK, NY 10003"
                },
                "geo": {
                    "lat": 40.733691,
                    "lon": -73.992963
                },
                "restaurantName": "Tokyo",
                "cuisines": ["Japanese"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "Daily: 12pm-11pm",
                "restaurant_phone": "(212) 229-1489",
                "restaurant_website": "",
                "restaurant_id": 4073369173992963
            }, {
                "address": {
                    "streetAddress": "1 W 13th St",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10011",
                    "formatted": "1 W 13th St New York, NY 10011"
                },
                "geo": {
                    "lat": 40.735328,
                    "lon": -73.99415
                },
                "restaurantName": "Mapi Espresso and Sandwich Bar",
                "cuisines": ["Coffee & Tea", "Hot Dogs", "Sandwiches"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "Mon-Fri: 7am-7pm Sat: 9am-4pm",
                "restaurant_phone": "(212) 929-1041",
                "restaurant_website": "",
                "restaurant_id": 4073532873994150
            }, {
                "address": {
                    "streetAddress": "116 University Pl",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10003",
                    "formatted": "116 University Pl New York, NY 10003"
                },
                "geo": {
                    "lat": 40.734552,
                    "lon": -73.992633
                },
                "restaurantName": "University Place Gourmet",
                "cuisines": ["Deli Food", "Sandwiches", "Sushi"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Daily: 24hrs",
                "restaurant_phone": "(212) 243-3139",
                "restaurant_website": "",
                "restaurant_id": 4073455273992633
            }, {
                "address": {
                    "streetAddress": "22 W 8th St",
                    "city": "NEW YORK",
                    "state": "NY",
                    "zip": "10011",
                    "formatted": "22 W 8th St NEW YORK, NY 10011"
                },
                "geo": {
                    "lat": 40.732739,
                    "lon": -73.997491
                },
                "restaurantName": "Jodie's Friends",
                "cuisines": ["Korean"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(212) 260-5645",
                "restaurant_website": "",
                "restaurant_id": 4073273973997491
            }, {
                "address": {
                    "streetAddress": "120 University Pl",
                    "city": "NEW YORK",
                    "state": "NY",
                    "zip": "10003",
                    "formatted": "120 University Pl NEW YORK, NY 10003"
                },
                "geo": {
                    "lat": 40.73485,
                    "lon": -73.992458
                },
                "restaurantName": "The Giant Bagel Shop",
                "cuisines": ["American", "Sandwiches", "Wraps"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "Open 24hrs",
                "restaurant_phone": "(212) 243-2775",
                "restaurant_website": "",
                "restaurant_id": 4073485073992458
            }, {
                "address": {
                    "streetAddress": "105 W 13th St",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10011",
                    "formatted": "105 W 13th St New York, NY 10011"
                },
                "geo": {
                    "lat": 40.736829,
                    "lon": -73.997684
                },
                "restaurantName": "Cafe Loup",
                "cuisines": ["Coffee & Tea", "French"],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "Sun-Mon: 12pm - 11:30pmTues-Sat: 12pm - 12am",
                "restaurant_phone": "(212) 255-4746",
                "restaurant_website": "http://www.cafeloupnyc.com/",
                "restaurant_id": 4073682973997684
            }, {
                "address": {
                    "streetAddress": "28 W 8th St",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10011",
                    "formatted": "28 W 8th St New York, NY 10011"
                },
                "geo": {
                    "lat": 40.732679,
                    "lon": -73.997952
                },
                "restaurantName": "8th Street Winecellar",
                "cuisines": ["Alcohol", "Tapas"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Daily: 4pm-2am",
                "restaurant_phone": "(212) 260-9463",
                "restaurant_website": "http://www.8thstwinecellar.com",
                "restaurant_id": 4073267973997952
            }, {
                "address": {
                    "streetAddress": "28 E 13th St",
                    "city": "New York",
                    "state": "NY",
                    "zip": "10003",
                    "formatted": "28 E 13th St New York, NY 10003"
                },
                "geo": {
                    "lat": 40.734742,
                    "lon": -73.99283
                },
                "restaurantName": "Souen",
                "cuisines": ["Asian Fusion", "Healthy", "Local/Organic", "Noodles", "Sushi"],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "Mon-Sat: 11am-10:30pm Sun: 11am-10pm",
                "restaurant_phone": "(212) 627-7150",
                "restaurant_website": "http://souen.net/souenusqmenu.html",
                "restaurant_id": 4073474273992830
            }, {
                "address": {
                    "streetAddress": "84 William St",
                    "city": "NEW YORK",
                    "state": "NY",
                    "zip": "10038",
                    "formatted": "84 William St NEW YORK, NY 10038"
                },
                "geo": {
                    "lat": 40.70797,
                    "lon": -74.007684
                },
                "restaurantName": "Lemongrass Grill",
                "cuisines": ["Thai"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "Mon-Fri: 11:30am-10:30pm Sat-Sun: 1pm-10:15pm Karaoke Bar: 5pm-11pm",
                "restaurant_phone": "(212) 809-8038",
                "restaurant_website": "http://www.lemongrassgrill.org",
                "restaurant_id": 4070797074007684
            }, {
                "address": {
                    "streetAddress": "122 University Pl",
                    "city": "NEW YORK",
                    "state": "NY",
                    "zip": "10003",
                    "formatted": "122 University Pl NEW YORK, NY 10003"
                },
                "geo": {
                    "lat": 40.734737,
                    "lon": -73.992087
                },
                "restaurantName": "California Pizza Deli And Falafel",
                "cuisines": ["American", "Deli Food"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "Daily: 6am-10pm",
                "restaurant_phone": "(212) 989-4225",
                "restaurant_website": "",
                "restaurant_id": 4073473773992087
            }],
            "numResults": 25
        }
    },
    restaurantSearchZip: {
        h4Id: 'res-search-zip',
        parameters: [{
                name: 'zip_code',
                description: 'Zip Code',
                type: 'string',
                required: "true",
                example: "11211",
                default: ''
            },
            {
                name: 'page',
                description: 'Page Through Results',
                type: 'number',
                required: "false",
                example: '1',
                default: '1'
            },
            {
                name: 'size',
                description: '# Of Results',
                type: 'number',
                required: "false",
                example: '10',
                default: '25 or 10'
            },
            {
                name: 'fullmenu',
                description: 'include full menus (or not)',
                type: 'Boolean',
                required: "false",
                example: 'false',
                default: 'false'
            }
        ],
        method: "GET",
        title: "Search Restaurants By Zip Code",
        description: "Search Function Returns Restaurants By Zip Code",
        endpoint: "/restaurants/zip/{zip}",
        exampleUrl: '/restaurants/zip/11211',
        exampleResponse: {
            "totalResults": 639,
            "page": 1,
            "total_pages": 26,
            "more_pages": true,
            "data": [{
                "address": {
                    "streetAddress": "169 Bedford Ave",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "169 Bedford Ave Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.71814,
                    "lon": -73.957176
                },
                "restaurantName": "Pokéworks",
                "cuisines": [""],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(718) 388-3121",
                "restaurant_website": "http:///ny/brooklyn/602034-pokeworks/",
                "restaurant_id": 4071814073957176
            }, {
                "address": {
                    "streetAddress": "349 Bedford Ave",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "349 Bedford Ave Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.711941,
                    "lon": -73.962662
                },
                "restaurantName": "Sakib Mediterranean Restaurant",
                "cuisines": [""],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(917) 909-0677",
                "restaurant_website": "http:///ny/brooklyn/603122-sakib-mediterranean-restaurant/",
                "restaurant_id": 4071194173962662
            }, {
                "address": {
                    "streetAddress": "637 Driggs Ave",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "637 Driggs Ave Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.715079,
                    "lon": -73.958543
                },
                "restaurantName": "San Loco",
                "cuisines": ["Mexican", "Vegetarian"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Sun-Wed: 11am-4am Thu-Sat: 11am-5am",
                "restaurant_phone": "(718) 218-8479",
                "restaurant_website": "http://sanloco.com/",
                "restaurant_id": 4071507973958543
            }, {
                "address": {
                    "streetAddress": "357 Graham Ave",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "357 Graham Ave Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.715103,
                    "lon": -73.944717
                },
                "restaurantName": "Late Night Stars Deli",
                "cuisines": [""],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(718) 599-1525",
                "restaurant_website": "http:///ny/brooklyn/602976-late-night-stars-deli/",
                "restaurant_id": 4071510373944717
            }, {
                "address": {
                    "streetAddress": "271 Metropolitan Ave",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "271 Metropolitan Ave Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.71492,
                    "lon": -73.958496
                },
                "restaurantName": "The Butcher's Daughter",
                "cuisines": [""],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(347) 763-1421",
                "restaurant_website": "http:///ny/brooklyn/604029-the-butchers-daughter/",
                "restaurant_id": 4071492073958496
            }, {
                "address": {
                    "streetAddress": "548 Driggs Ave",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "548 Driggs Ave Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.717316,
                    "lon": -73.956543
                },
                "restaurantName": "Woops! Williamsburg",
                "cuisines": [""],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(718) 384-4410",
                "restaurant_website": "http:///ny/brooklyn/605701-woops-williamsburg/",
                "restaurant_id": 4071731673956543
            }, {
                "address": {
                    "streetAddress": "165 Bedford Ave",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "165 Bedford Ave Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.718403,
                    "lon": -73.956924
                },
                "restaurantName": "Xian Town",
                "cuisines": [""],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(718) 486-6868",
                "restaurant_website": "http:///ny/brooklyn/606466-xian-town/",
                "restaurant_id": 4071840373956924
            }, {
                "address": {
                    "streetAddress": "351 Bedford Ave",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "351 Bedford Ave Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.71175,
                    "lon": -73.962799
                },
                "restaurantName": "Aden Food Market",
                "cuisines": [""],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(718) 388-4868",
                "restaurant_website": "http:///ny/brooklyn/607185-aden-food-market/",
                "restaurant_id": 4071175073962799
            }, {
                "address": {
                    "streetAddress": "357 Grand St",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "357 Grand St Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.712368,
                    "lon": -73.955551
                },
                "restaurantName": "Gertie",
                "cuisines": [""],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(718) 636-0902",
                "restaurant_website": "http:///ny/brooklyn/621730-gertie/",
                "restaurant_id": 4071236873955551
            }, {
                "address": {
                    "streetAddress": "137 Havemeyer St",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "137 Havemeyer St Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.712025,
                    "lon": -73.957077
                },
                "restaurantName": "Uncle Zack of Brooklyn",
                "cuisines": [""],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(347) 763-0987",
                "restaurant_website": "http:///ny/brooklyn/623184-uncle-zack-of-brooklyn/",
                "restaurant_id": 4071202573957077
            }, {
                "address": {
                    "streetAddress": "242 Metropolitan Ave",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "242 Metropolitan Ave Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.714871,
                    "lon": -73.95948
                },
                "restaurantName": "Tacombi",
                "cuisines": [""],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(718) 599-3496",
                "restaurant_website": "http:///ny/brooklyn/624715-tacombi/",
                "restaurant_id": 4071487173959480
            }, {
                "address": {
                    "streetAddress": "544 Union Ave",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "544 Union Ave Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.717091,
                    "lon": -73.951721
                },
                "restaurantName": "Reunion",
                "cuisines": ["Coffee & Tea", "Local/Organic"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Mon-Sat: 7:30am-7pm Sun: 9am-5pm",
                "restaurant_phone": "(718) 599-3670",
                "restaurant_website": "",
                "restaurant_id": 4071709173951721
            }, {
                "address": {
                    "streetAddress": "177 Bedford Ave",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "177 Bedford Ave Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.718,
                    "lon": -73.957491
                },
                "restaurantName": "Sujo",
                "cuisines": ["Barbecue", "Korean"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Daily: 11am-12am",
                "restaurant_phone": "(718) 576-3793",
                "restaurant_website": "",
                "restaurant_id": 4071800073957491
            }, {
                "address": {
                    "streetAddress": "287 Bedford Ave",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "287 Bedford Ave Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.71428,
                    "lon": -73.961312
                },
                "restaurantName": "Maison des Crepes",
                "cuisines": ["Coffee & Tea", "Crepes", "Desserts", "Smoothies & Juices"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Sun-Thu: 9am-10pm Fri-Sat: 9am-12am",
                "restaurant_phone": "(718) 486-5150",
                "restaurant_website": "",
                "restaurant_id": 4071428073961312
            }, {
                "address": {
                    "streetAddress": "804 Grand St",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "804 Grand St Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.71184,
                    "lon": -73.941207
                },
                "restaurantName": "Sky Bar & Grill",
                "cuisines": ["American"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Mon: 8am-9pm Tue-Wed, Sun: 8am-12am Thu: 8am-2am Fri-Sat: 8am-3am ",
                "restaurant_phone": "(718) 384-4455",
                "restaurant_website": "",
                "restaurant_id": 4071184073941207
            }, {
                "address": {
                    "streetAddress": "1543 Broadway",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "1543 Broadway Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.68634,
                    "lon": -73.916528
                },
                "restaurantName": "East Broadway Cafe",
                "cuisines": ["Caribbean", "Soul Food"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Tue-Sun: 9am-11pm",
                "restaurant_phone": "(347) 770-8637",
                "restaurant_website": "",
                "restaurant_id": 4068634073916528
            }, {
                "address": {
                    "streetAddress": "800 Grand St",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "800 Grand St Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.71177,
                    "lon": -73.941361
                },
                "restaurantName": "Grand Street Pizza",
                "cuisines": ["Italian", "Pizza"],
                "menus": [],
                "priceRange": "$$$",
                "priceRangeNum": 3,
                "hours": "Daily: 11am-11pm",
                "restaurant_phone": "(347) 916-0909",
                "restaurant_website": "",
                "restaurant_id": 4071177073941361
            }, {
                "address": {
                    "streetAddress": "145 Borinquen Pl",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "145 Borinquen Pl Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.710843,
                    "lon": -73.953785
                },
                "restaurantName": "Wei Williamsburg",
                "cuisines": ["Chinese"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Delivery Daily: 12pm-1:45am",
                "restaurant_phone": "(347) 844-9297",
                "restaurant_website": "",
                "restaurant_id": 4071084373953785
            }, {
                "address": {
                    "streetAddress": "502 Grand St",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "502 Grand St Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.71095,
                    "lon": -73.951112
                },
                "restaurantName": "Chuvoys",
                "cuisines": ["Diner", "Mexican"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Sun-Thu: 8am-12am Fri-Sat: 8am-3am",
                "restaurant_phone": "(347) 763-1548",
                "restaurant_website": "",
                "restaurant_id": 4071095073951112
            }, {
                "address": {
                    "streetAddress": "297 Broadway",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "297 Broadway Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.70865,
                    "lon": -73.958
                },
                "restaurantName": "Otha's Coffee",
                "cuisines": ["American"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "",
                "restaurant_phone": "(915) 525-4090",
                "restaurant_website": "",
                "restaurant_id": 4070865073958000
            }, {
                "address": {
                    "streetAddress": "129 Havemeyer St",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "129 Havemeyer St Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.71225,
                    "lon": -73.957053
                },
                "restaurantName": "Hummus Kitchen",
                "cuisines": ["Mediterranean", "Middle Eastern"],
                "menus": [],
                "priceRange": "$$$",
                "priceRangeNum": 3,
                "hours": "Daily: 11am-11pm",
                "restaurant_phone": "(347) 689-2357",
                "restaurant_website": "",
                "restaurant_id": 4071225073957053
            }, {
                "address": {
                    "streetAddress": "149 Broadway",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "149 Broadway Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.710423,
                    "lon": -73.963127
                },
                "restaurantName": "Meadowsweet",
                "cuisines": ["American (New)"],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "Mon-Thu: 6pm-12am Fri-Sat: 6pm-1am Sun: 5:30pm-11:30pm",
                "restaurant_phone": "(718) 384-0673",
                "restaurant_website": "http://www.meadowsweetnyc.com",
                "restaurant_id": 4071042373963127
            }, {
                "address": {
                    "streetAddress": "434 Humboldt St",
                    "city": "BROOKLYN",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "434 Humboldt St BROOKLYN, NY 11211"
                },
                "geo": {
                    "lat": 40.716942,
                    "lon": -73.942871
                },
                "restaurantName": "Humboldt & Jackson",
                "cuisines": ["American (New)", "Tapas"],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "Mon-Thu, Sun: 5pm-12am Fri-Sat: 5pm-1am",
                "restaurant_phone": "(718) 349-3355",
                "restaurant_website": "http://humboldtandjackson.com/menu/",
                "restaurant_id": 4071694273942871
            }, {
                "address": {
                    "streetAddress": "10 Devoe St",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "10 Devoe St Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.712933,
                    "lon": -73.950992
                },
                "restaurantName": "10 Devoe",
                "cuisines": ["Italian", "Pizza"],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "Sun-Thu: 5pm-11pm Fri-Sat: 5pm-1am",
                "restaurant_phone": "(718) 938-6629",
                "restaurant_website": "http://www.10devoe.com",
                "restaurant_id": 4071293373950992
            }, {
                "address": {
                    "streetAddress": "524 Grand St",
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11211",
                    "formatted": "524 Grand St Brooklyn, NY 11211"
                },
                "geo": {
                    "lat": 40.71092,
                    "lon": -73.950379
                },
                "restaurantName": "The Grand National",
                "cuisines": ["Bar Food", "Hot Dogs"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Mon-Fri: 4pm-4am Sat-Sun: 12pm-4am",
                "restaurant_phone": "(347) 725-4386",
                "restaurant_website": "",
                "restaurant_id": 4071092073950379
            }],
            "numResults": 25
        }
    },
    restaurantSearchState: {
        h4Id: 'res-search-state',
        parameters: [{
                name: 'state_code',
                description: '2 Digit State Code',
                type: 'string',
                required: "true",
                example: "NY",
                default: ''
            },
            {
                name: 'page',
                description: 'Page Through Results',
                type: 'number',
                required: "false",
                example: '1',
                default: '1'
            },
            {
                name: 'size',
                description: '# Of Results',
                type: 'number',
                required: "false",
                example: '10',
                default: '25 or 10'
            },
            {
                name: 'fullmenu',
                description: 'include full menus (or not)',
                type: 'Boolean',
                required: "false",
                example: 'false',
                default: 'false'
            }
        ],
        method: "GET",
        title: "Search Restaurants By State",
        description: "Search Function Returns Restaurants By State Code",
        endpoint: "/restaurants/state/{state_code}",
        exampleUrl: '/restaurants/state/NY',
        exampleResponse: {
            "totalResults": 54822,
            "page": "2",
            "total_pages": 5483,
            "more_pages": true,
            "data": [{
                "address": {
                    "streetAddress": "22415 Linden Blvd",
                    "city": "CAMBRIA HEIGHTS",
                    "state": "NY",
                    "zip": "11411",
                    "formatted": "22415 Linden Blvd CAMBRIA HEIGHTS, NY 11411"
                },
                "geo": {
                    "lat": 40.694004,
                    "lon": -73.736502
                },
                "restaurantName": "Boston Jerk",
                "cuisines": ["Jamaican"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(718) 525-8284",
                "restaurant_website": "",
                "restaurant_id": 4069400473736502
            }, {
                "address": {
                    "streetAddress": "231-11 Linden Blvd",
                    "city": "Cambria Heights",
                    "state": "NY",
                    "zip": "11411",
                    "formatted": "231-11 Linden Blvd Cambria Heights, NY 11411"
                },
                "geo": {
                    "lat": 40.691913,
                    "lon": -73.730587
                },
                "restaurantName": "Kitchen King",
                "cuisines": ["Jamaican"],
                "menus": [],
                "priceRange": "$$",
                "priceRangeNum": 2,
                "hours": "Mon-Fri: 9am-9pm Sat-Sun: 9am-11pm",
                "restaurant_phone": "(718) 978-1818",
                "restaurant_website": "",
                "restaurant_id": 4069191373730587
            }, {
                "address": {
                    "streetAddress": "2218 Sound Avenue",
                    "city": "Calverton",
                    "state": "NY",
                    "zip": "11933",
                    "formatted": "2218 Sound Avenue Calverton, NY 11933"
                },
                "geo": {
                    "lat": 40.95627,
                    "lon": -72.751096
                },
                "restaurantName": "Cooperage Inn",
                "cuisines": [""],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "",
                "restaurant_phone": "(631) 727-8994",
                "restaurant_website": "http://www.cooperageinn.com/",
                "restaurant_id": 4095627072751096
            }, {
                "address": {
                    "streetAddress": "4486 Middle Country Rd",
                    "city": "Calverton",
                    "state": "NY",
                    "zip": "11933",
                    "formatted": "4486 Middle Country Rd Calverton, NY 11933"
                },
                "geo": {
                    "lat": 40.928509,
                    "lon": -72.781342
                },
                "restaurantName": "Golden Jalapenos Cafe",
                "cuisines": [""],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(631) 740-9500",
                "restaurant_website": "http:///ny/calverton/546532-golden-jalapenos-cafe/",
                "restaurant_id": 4092850972781342
            }, {
                "address": {
                    "streetAddress": "116-32 Springfield Blvd",
                    "city": "Cambria Heights",
                    "state": "NY",
                    "zip": "11411",
                    "formatted": "116-32 Springfield Blvd Cambria Heights, NY 11411"
                },
                "geo": {
                    "lat": 40.697005,
                    "lon": -73.743396
                },
                "restaurantName": "Hot Pot",
                "cuisines": ["Caribbean", "Jamaican"],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "Daily: 24hrs",
                "restaurant_phone": "(718) 949-3166",
                "restaurant_website": "",
                "restaurant_id": 4069700573743396
            }, {
                "address": {
                    "streetAddress": "224-12 Linden Blvd",
                    "city": "Cambria Heights",
                    "state": "NY",
                    "zip": "11411",
                    "formatted": "224-12 Linden Blvd Cambria Heights, NY 11411"
                },
                "geo": {
                    "lat": 40.694009,
                    "lon": -73.736519
                },
                "restaurantName": "New Great Dragon",
                "cuisines": ["Chinese"],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "Mon-Thu: 11am-11:30pm Fri-Sat: 11am-12am Sun: 1pm-10:30pm",
                "restaurant_phone": "(718) 723-0831",
                "restaurant_website": "",
                "restaurant_id": 4069400973736519
            }, {
                "address": {
                    "streetAddress": "22125 Linden Blvd",
                    "city": "CAMBRIA HEIGHTS",
                    "state": "NY",
                    "zip": "11411",
                    "formatted": "22125 Linden Blvd CAMBRIA HEIGHTS, NY 11411"
                },
                "geo": {
                    "lat": 40.694799,
                    "lon": -73.73905
                },
                "restaurantName": "Great Wall",
                "cuisines": ["Chinese"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(718) 723-7221",
                "restaurant_website": "",
                "restaurant_id": 4069479973739050
            }, {
                "address": {
                    "streetAddress": "21619 Linden Blvd",
                    "city": "CAMBRIA HEIGHTS",
                    "state": "NY",
                    "zip": "11411",
                    "formatted": "21619 Linden Blvd CAMBRIA HEIGHTS, NY 11411"
                },
                "geo": {
                    "lat": 40.696169,
                    "lon": -73.743366
                },
                "restaurantName": "Crown Fried Chicken & Pizza",
                "cuisines": ["American", "Deli Food"],
                "menus": [],
                "priceRange": "",
                "priceRangeNum": "",
                "hours": "",
                "restaurant_phone": "(718) 527-1500",
                "restaurant_website": "",
                "restaurant_id": 4069616973743366
            }, {
                "address": {
                    "streetAddress": "22011 Linden Blvd",
                    "city": "Cambria Heights",
                    "state": "NY",
                    "zip": "11411",
                    "formatted": "22011 Linden Blvd Cambria Heights, NY 11411"
                },
                "geo": {
                    "lat": 40.695111,
                    "lon": -73.740044
                },
                "restaurantName": "Little Rabbit Chinese Restaurant",
                "cuisines": ["Chinese"],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "Mon-Thu: 11am-11pm Fri-Sat: 11am-12am Sun: 12pm-10pm",
                "restaurant_phone": "(718) 723-4670",
                "restaurant_website": "",
                "restaurant_id": 4069511173740044
            }, {
                "address": {
                    "streetAddress": "228-03 Linden Blvd",
                    "city": "Cambria Heights",
                    "state": "NY",
                    "zip": "11411",
                    "formatted": "228-03 Linden Blvd Cambria Heights, NY 11411"
                },
                "geo": {
                    "lat": 40.692884,
                    "lon": -73.732958
                },
                "restaurantName": "Linden Superette",
                "cuisines": ["Deli Food", "Sandwiches"],
                "menus": [],
                "priceRange": "$",
                "priceRangeNum": 1,
                "hours": "Daily: 24hrs",
                "restaurant_phone": "(718) 978-1275",
                "restaurant_website": "",
                "restaurant_id": 4069288473732958
            }],
            "numResults": 10
        }
    },
    itemById: {
        h4Id: 'menu-id',
        parameters: [{
            name: 'item_id',
            description: 'Numeric ID of the Item to Get.',
            type: 'number',
            required: "true",
            example: '1591156531'
        }],
        method: "GET",
        title: "Get Menu Item By ID",
        description: "Return Single Menu Item Details",
        endpoint: "/menuitem/{item_id}",
        exampleUrl: '/menuitem/1591156531',
        exampleResponse: {
            "result": {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "139 Montague St",
                    "formatted": "139 Montague St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.694863,
                    "lon": -73.993711
                },
                "itemId": "8861876644798123621",
                "menuItemName": "Half Tray Beef, Buffalo Chicken or Turkey Sliders (35 Pieces)",
                "menuItemDescription": "Beef, Buffalo Chicken or Turkey Sliders w/ French Fries or House Salad",
                "price": 95,
                "restaurant_id": 4069486373993711,
                "restaurantName": "The Custom House",
                "restaurant_phone": "(718) 643-6000",
                "hours": "Mon-Wed: 11am-11pm Thu-Fri: 11am-1am Sat: 10am-1am Sun: 10am-11pm",
                "subsectionName": "Catering & Party Orders",
                "subsectionDescription": "Selection of Items available in Full & Half Tray Sizes. Items MUST Be Ordered a Mimimum 24 HOURS Prior to required time."
            }
        }
    },
    itemByRestaurantId: {
        h4Id: 'menu-rest-id',
        parameters: [{
                name: 'restaurant_id',
                description: 'Numeric ID of the restaurant to get.',
                type: 'number',
                required: "true",
                example: 317120
            },
            {
                name: 'size',
                description: '# Of Results',
                type: 'number',
                required: "false",
                example: '10',
                default: '25 or 10'
            },
            {
                name: 'page',
                description: 'Page Through Results',
                type: 'number',
                required: "false",
                example: '1',
                default: '1'
            }
        ],
        method: "GET",
        title: "Menu Items For Restaurant",
        description: "Get Menu Items For Specific Restaurant ID",
        endpoint: "/restaurant/{restaurant_id}/menuitems",
        exampleUrl: '/restaurant/4074837073982692/menuitems',
        exampleResponse: {
            "totalResults": 36,
            "page": 1,
            "total_pages": 2,
            "more_pages": true,
            "data": [{
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "9920960453800005261",
                "menuItemName": "Flavored Tea",
                "menuItemDescription": "",
                "price": 1.5,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Drinks",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "14495127945067785838",
                "menuItemName": "Grilled Chicken and Avocado Salad",
                "menuItemDescription": "Served over tossed salad.",
                "price": 6.5,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Salads",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "17710397071979520783",
                "menuItemName": "Grilled Steak Taco Salad",
                "menuItemDescription": "Served with yellow rice, beans, tossed salad, sour cream and guacamole.",
                "price": 6,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Taco Salad",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "2986782845817465977",
                "menuItemName": "Grilled Chicken Pita",
                "menuItemDescription": "Grilled chicken, lettuce, tomato, onions and white sauce in a pita. Combos served with small potato chips and choice of canned soda or small water.",
                "price": 5,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Special Sandwiches",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "7496049557450760067",
                "menuItemName": "Grilled Chicken Caesar Salad Wrap",
                "menuItemDescription": "Combos served with small potato chips and choice of canned soda or small water.",
                "price": 5,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Wraps",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "10469604760049050926",
                "menuItemName": "Grilled Steak with Onions Wrap",
                "menuItemDescription": "With lettuce, tomato and mayo. Combos served with small potato chips and choice of canned soda or small water.",
                "price": 5,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Wraps",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "16223236110015817992",
                "menuItemName": "Grilled Chicken Burrito",
                "menuItemDescription": "Served with rice, salad, beans, guacamole and sour cream. Combos served with small potato chips and choice of canned soda or small water.",
                "price": 6,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Burritos",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "9595535099394772169",
                "menuItemName": "Fresh Grilled Chicken Lunch Special",
                "menuItemDescription": "Served with tossed salad and yellow rice.",
                "price": 5,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Lunch Special Platters",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "11453330426918796582",
                "menuItemName": "Buttered Bagel",
                "menuItemDescription": "",
                "price": 1,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Breakfast Special",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "1167042150516826945",
                "menuItemName": "2 Eggs Any Style and Bacon",
                "menuItemDescription": "Served with home fries and toast.",
                "price": 3.75,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Breakfast Platters",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "7397837183903256354",
                "menuItemName": "Low Cholesterol Omelette",
                "menuItemDescription": "Egg whites, onions, peppers and tomato. Served with home fries and toast.",
                "price": 4,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Breakfast Platters",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "17969661929274340147",
                "menuItemName": "Ham and Cheese Omelette",
                "menuItemDescription": "Ham and American or Swiss cheese. Served with home fries and toast.",
                "price": 4,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Breakfast Platters",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "973371477648912377",
                "menuItemName": "Ham and American Cheese Croissant",
                "menuItemDescription": "",
                "price": 3,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Breakfast Sandwiches",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "11437235299296154946",
                "menuItemName": "Lamb Gyros",
                "menuItemDescription": "Lamb, lettuce, tomato, onions and white sauce in a pita. Combos served with small potato chips and choice of canned soda or small water.",
                "price": 5,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Special Sandwiches",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "64542873635242812",
                "menuItemName": "Grilled Steak Burrito",
                "menuItemDescription": "Served with rice, salad, beans, guacamole and sour cream. Combos served with small potato chips and choice of canned soda or small water.",
                "price": 6,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Burritos",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "820737011207481064",
                "menuItemName": "Fresh Roast Pork Lunch Special",
                "menuItemDescription": "Served with tossed salad and yellow rice.",
                "price": 5,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Lunch Special Platters",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "13472599086237715653",
                "menuItemName": "Fresh Roast Pork Burrito",
                "menuItemDescription": "Served with rice, salad, beans, guacamole and sour cream. Combos served with small potato chips and choice of canned soda or small water.",
                "price": 6,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Burritos",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "15535248642930720684",
                "menuItemName": "2 Eggs and Meat on a Roll",
                "menuItemDescription": "",
                "price": 2.75,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Breakfast Sandwiches",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "3081451423732866849",
                "menuItemName": "2 Eggs and American Cheese Croissant",
                "menuItemDescription": "",
                "price": 3.75,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Breakfast Sandwiches",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "10090038395075378496",
                "menuItemName": "2 Eggs, Bacon and American Cheese Croissant",
                "menuItemDescription": "",
                "price": 4,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Breakfast Sandwiches",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "6337473044778387862",
                "menuItemName": "Grilled Chicken Taco Salad",
                "menuItemDescription": "Served with yellow rice, beans, tossed salad, sour cream and guacamole.",
                "price": 6,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Taco Salad",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "13374416440470323894",
                "menuItemName": "Grilled Chicken and Avocado Sandwich",
                "menuItemDescription": "Grilled chicken, avocado, lettuce and tomato on a roll. Combos served with small potato chips and choice of canned soda or small water.",
                "price": 5,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Special Sandwiches",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "2681440063051624786",
                "menuItemName": "Tuna and Avocado Wrap",
                "menuItemDescription": "With lettuce and tomato. Combos served with small potato chips and choice of canned soda or small water.",
                "price": 5,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Wraps",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "13398705451349333371",
                "menuItemName": "Ham and American Cheese Wrap",
                "menuItemDescription": "Lettuce, tomato and mayo. Combos served with small potato chips and choice of canned soda or small water.",
                "price": 5,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Wraps",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Manhattan",
                    "state": "NY",
                    "zip": "10016",
                    "streetAddress": "198 Madison Ave",
                    "formatted": "198 Madison Ave Manhattan, NY 10016"
                },
                "geo": {
                    "lat": 40.74837,
                    "lon": -73.982692
                },
                "itemId": "15877062330359077286",
                "menuItemName": "Grilled Chicken BLT Wrap",
                "menuItemDescription": "With mayo. Combos served with small potato chips and choice of canned soda or small water.",
                "price": 5,
                "restaurant_id": 4074837073982692,
                "restaurantName": "Cafe 35",
                "restaurant_phone": "(718) 578-9926",
                "hours": "",
                "subsectionName": "Wraps",
                "subsectionDescription": "",
                "menus": []
            }],
            "numResults": 25
        }
    },
    menuitemSearchGeo: {
        h4Id: 'menu-search-geo',
        parameters: [{
                name: 'lat',
                description: 'Latitude of search area',
                type: 'number',
                required: "true",
                example: 40.68919,
                default: ''
            },
            {
                name: 'lon',
                description: 'Longitude of search area',
                type: 'number',
                required: "true",
                example: -73.992378,
                default: ''
            },
            {
                name: 'distance',
                description: 'Search Area radius (in miles)',
                type: 'number',
                required: "true",
                example: 5,
                default: ''
            },
            {
                name: 'search',
                description: 'Query String',
                type: 'string',
                required: "false",
                example: 'pizza',
                default: ''
            },
            {
                name: 'page',
                description: 'Page Through Results',
                type: 'number',
                required: "false",
                example: '1',
                default: '1'
            },
            {
                name: 'size',
                description: '# Of Results',
                type: 'number',
                required: "false",
                example: '10',
                default: '25 or 10'
            }

        ],
        method: "GET",
        title: "Search Menu Items By Geo Location",
        description: "Search Function using location and search radius. Returns list of menu items sorted by closest",
        endpoint: "/menuitems/search/geo",
        exampleUrl: '/menuitems/search/geo?lat=40.688072&lon=-73.997385&distance=1&search=buffalo%20chicken',
        exampleResponse: {
            "totalResults": 37,
            "page": 1,
            "total_pages": 2,
            "more_pages": true,
            "data": [{
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "218 Court St",
                    "formatted": "218 Court St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.686561,
                    "lon": -73.993876
                },
                "itemId": "16443917058969997538",
                "menuItemName": "Buffalo Chicken Quesadilla",
                "menuItemDescription": "Deep-fried chicken breast with buffalo sauce and jack cheese also available with Sara's bbq sauce",
                "price": 11,
                "restaurant_id": 4068656173993876,
                "restaurantName": "Lobo Cobble Hill",
                "restaurant_phone": "(718) 858-7739",
                "hours": "Mon-Wed: 11am-11pm Thu: 11am-12am Fri-Sat: 10am-12am Sun 10am-11pm ",
                "subsectionName": "Sandwiches",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "BROOKLYN",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "216 Atlantic Ave",
                    "formatted": "216 Atlantic Ave BROOKLYN, NY 11201"
                },
                "geo": {
                    "lat": 40.689575,
                    "lon": -73.992021
                },
                "itemId": "11403372241687787180",
                "menuItemName": "Buffalo Chicken",
                "menuItemDescription": "All that cool, creamy ranch, poured over tender glazed buffalo chicken",
                "price": 0,
                "restaurant_id": 4068957573992021,
                "restaurantName": "Subway",
                "restaurant_phone": "(718) 643-9955",
                "hours": "",
                "subsectionName": "All Sandwiches",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11231",
                    "streetAddress": "314 Court St",
                    "formatted": "314 Court St Brooklyn, NY 11231"
                },
                "geo": {
                    "lat": 40.68348,
                    "lon": -73.995478
                },
                "itemId": "12957348642568376626",
                "menuItemName": "Appetizer Sampler",
                "menuItemDescription": "2 pieces chicken fingers, 3 pieces mozzarella sticks and 4 Buffalo wings. served with bleu cheese dressing and marinara sauce for dipping.",
                "price": 15.95,
                "restaurant_id": 4068348073995478,
                "restaurantName": "Cobble Hill Coffee Shop",
                "restaurant_phone": "(718) 852-1162",
                "hours": "Daily: 7am-11pm",
                "subsectionName": "Snacks and Appetizers",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11231",
                    "streetAddress": "314 Court St",
                    "formatted": "314 Court St Brooklyn, NY 11231"
                },
                "geo": {
                    "lat": 40.68348,
                    "lon": -73.995478
                },
                "itemId": "14950223557847285984",
                "menuItemName": "Buffalo Crispy Chicken Wrap",
                "menuItemDescription": "Chicken cutlet with Buffalo sauce, lettuce, tomato and Gorgonzola.",
                "price": 13.95,
                "restaurant_id": 4068348073995478,
                "restaurantName": "Cobble Hill Coffee Shop",
                "restaurant_phone": "(718) 852-1162",
                "hours": "Daily: 7am-11pm",
                "subsectionName": "Wraps",
                "subsectionDescription": "Served with homemade potato chips or french fries, coleslaw and pickle.",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "113 Court St",
                    "formatted": "113 Court St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.690601,
                    "lon": -73.99179
                },
                "itemId": "15901119599725883291",
                "menuItemName": "A6. Buffalo Chicken Wings",
                "menuItemDescription": "With celery and blue cheese dressing.",
                "price": 10.99,
                "restaurant_id": 4069060173991790,
                "restaurantName": "Fresco Tortilla",
                "restaurant_phone": "(718) 237-8898",
                "hours": "Mon-Fri: 11am-10:30pm Sat: 11:30am-10:30pm Sun: 11:30am-10pm",
                "subsectionName": "Appetizers",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "155 Smith St",
                    "formatted": "155 Smith St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.686454,
                    "lon": -73.990543
                },
                "itemId": "15336902297203906194",
                "menuItemName": "The Sampler",
                "menuItemDescription": "Mozzarella sticks, Buffalo wings, chicken fingers, and zucchini sticks.",
                "price": 21.95,
                "restaurant_id": 4068645473990543,
                "restaurantName": "Carroll Gardens Classic Diner",
                "restaurant_phone": "(718) 269-4044",
                "hours": "Daily: 24 Hrs",
                "subsectionName": "Appetizers that Tantalize",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "126 Smith St",
                    "formatted": "126 Smith St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.687535,
                    "lon": -73.990175
                },
                "itemId": "1271653991736350130",
                "menuItemName": "3. Buffalo Blazing Chicken Breast",
                "menuItemDescription": "pepper jack cheese, beef steak tomato, will poblano & black bean puree",
                "price": 0,
                "restaurant_id": 4068753573990175,
                "restaurantName": "Chop Chop",
                "restaurant_phone": "(718) 858-3757",
                "hours": "Daily: 7am-10pm",
                "subsectionName": "Panini Special $6.50",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11231",
                    "streetAddress": "132 Union St",
                    "formatted": "132 Union St Brooklyn, NY 11231"
                },
                "geo": {
                    "lat": 40.683915,
                    "lon": -74.002226
                },
                "itemId": "13924113221450766692",
                "menuItemName": "Buffalo Chicken Pizza",
                "menuItemDescription": "No wipes necessary!! All white meat chicken, smothered in 'Franks Original Buffalo Wing Sauce', topped with mozzarella and finished with cool Ranch dressing.",
                "price": 28,
                "restaurant_id": 4068391574002226,
                "restaurantName": "The House of Pizza & Calzones",
                "restaurant_phone": "(718) 624-9107",
                "hours": "Mon-Thu: 11am-9pm Fri-Sat: 11am-10pm Sun: 11:30am-7:30pm",
                "subsectionName": "Specialty Pizza",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "BROOKLYN",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "102 Smith St",
                    "formatted": "102 Smith St BROOKLYN, NY 11201"
                },
                "geo": {
                    "lat": 40.688209,
                    "lon": -73.989457
                },
                "itemId": "14676281661092395725",
                "menuItemName": "Buffalo Chicken Sandwich",
                "menuItemDescription": "fried chicken breast tossed in buffalo sauce on a hero with bleu cheese dressing",
                "price": 10,
                "restaurant_id": 4068820973989457,
                "restaurantName": "Gravy",
                "restaurant_phone": "(718) 935-1294",
                "hours": "",
                "subsectionName": "Sandwiches",
                "subsectionDescription": "comes with your choice of french fries or potato salad",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11231",
                    "streetAddress": "269 Smith St",
                    "formatted": "269 Smith St Brooklyn, NY 11231"
                },
                "geo": {
                    "lat": 40.682615,
                    "lon": -73.993106
                },
                "itemId": "7440052314919549075",
                "menuItemName": "The Great White Buffalo Pizza",
                "menuItemDescription": "Fresh mozzarella, franks buffalo sauce , chicken, blue cheese , fontina, cherry peppers.",
                "price": 20,
                "restaurant_id": 4068261573993106,
                "restaurantName": "Brooklyn Pizza Market",
                "restaurant_phone": "(347) 422-0436",
                "hours": "",
                "subsectionName": "Pizzas",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "148 Montague St",
                    "formatted": "148 Montague St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.694359,
                    "lon": -73.993393
                },
                "itemId": "12632611522660948224",
                "menuItemName": "Happy Days Sampler",
                "menuItemDescription": "3 mozzarella sticks, 2 chicken fingers and 3 Buffalo wings.",
                "price": 13.25,
                "restaurant_id": 4069435973993393,
                "restaurantName": "Happy Days Diner",
                "restaurant_phone": "(718) 875-8361",
                "hours": "Daily: 24 Hours",
                "subsectionName": "Finger Snacks",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "148 Montague St",
                    "formatted": "148 Montague St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.694359,
                    "lon": -73.993393
                },
                "itemId": "18205400124084026790",
                "menuItemName": "Happy Days Deluxe Sampler",
                "menuItemDescription": "3 mozzarella sticks, 2 chicken fingers, 3 Buffalo wings and french fries.",
                "price": 16.25,
                "restaurant_id": 4069435973993393,
                "restaurantName": "Happy Days Diner",
                "restaurant_phone": "(718) 875-8361",
                "hours": "Daily: 24 Hours",
                "subsectionName": "Finger Snacks",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "148 Montague St",
                    "formatted": "148 Montague St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.694359,
                    "lon": -73.993393
                },
                "itemId": "9718357536855060076",
                "menuItemName": "Happy Days Specials Kids",
                "menuItemDescription": "2 mozzarella sticks, 2 chicken fingers, and 3 Buffalo wings.",
                "price": 13.95,
                "restaurant_id": 4069435973993393,
                "restaurantName": "Happy Days Diner",
                "restaurant_phone": "(718) 875-8361",
                "hours": "Daily: 24 Hours",
                "subsectionName": "Kids Special",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "139 Montague St",
                    "formatted": "139 Montague St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.694863,
                    "lon": -73.993711
                },
                "itemId": "12803568219661769958",
                "menuItemName": "Buffalo Chicken Sliders",
                "menuItemDescription": "2 pieces with blue cheese dressing. Served with fries or salad.",
                "price": 13.95,
                "restaurant_id": 4069486373993711,
                "restaurantName": "The Custom House",
                "restaurant_phone": "(718) 643-6000",
                "hours": "Mon-Wed: 11am-11pm Thu-Fri: 11am-1am Sat: 10am-1am Sun: 10am-11pm",
                "subsectionName": "Sliders",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "139 Montague St",
                    "formatted": "139 Montague St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.694863,
                    "lon": -73.993711
                },
                "itemId": "12967082864659742972",
                "menuItemName": "The Slider Platter",
                "menuItemDescription": "2 beef sliders, 2 buffalo chicken sliders and 2 turkey sliders. Served with fries or salad.",
                "price": 30.95,
                "restaurant_id": 4069486373993711,
                "restaurantName": "The Custom House",
                "restaurant_phone": "(718) 643-6000",
                "hours": "Mon-Wed: 11am-11pm Thu-Fri: 11am-1am Sat: 10am-1am Sun: 10am-11pm",
                "subsectionName": "Sliders",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "139 Montague St",
                    "formatted": "139 Montague St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.694863,
                    "lon": -73.993711
                },
                "itemId": "16122745785748717963",
                "menuItemName": "Full Tray Beef, Buffalo Chicken or Turkey Sliders (70 Pieces)",
                "menuItemDescription": "Beef, Buffalo Chicken or Turkey Sliders w/ French Fries or Salad",
                "price": 170,
                "restaurant_id": 4069486373993711,
                "restaurantName": "The Custom House",
                "restaurant_phone": "(718) 643-6000",
                "hours": "Mon-Wed: 11am-11pm Thu-Fri: 11am-1am Sat: 10am-1am Sun: 10am-11pm",
                "subsectionName": "Catering & Party Orders",
                "subsectionDescription": "Selection of Items available in Full & Half Tray Sizes. Items MUST Be Ordered a Mimimum 24 HOURS Prior to required time.",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "139 Montague St",
                    "formatted": "139 Montague St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.694863,
                    "lon": -73.993711
                },
                "itemId": "9796958481776074393",
                "menuItemName": "The Slider Combo",
                "menuItemDescription": "Two beef, two Buffalo chicken, two turkey and two crab. Served with fries or salad or sweet potato fries",
                "price": 27.95,
                "restaurant_id": 4069486373993711,
                "restaurantName": "The Custom House",
                "restaurant_phone": "(718) 643-6000",
                "hours": "Mon-Wed: 11am-11pm Thu-Fri: 11am-1am Sat: 10am-1am Sun: 10am-11pm",
                "subsectionName": "Sliders",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "139 Montague St",
                    "formatted": "139 Montague St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.694863,
                    "lon": -73.993711
                },
                "itemId": "4509409166777294503",
                "menuItemName": "The Combo Slider Platter",
                "menuItemDescription": "2 beef sliders, 2 buffalo chicken sliders, 2 turkey sliders and 2 crab sliders. Served with fries or salad.",
                "price": 34.95,
                "restaurant_id": 4069486373993711,
                "restaurantName": "The Custom House",
                "restaurant_phone": "(718) 643-6000",
                "hours": "Mon-Wed: 11am-11pm Thu-Fri: 11am-1am Sat: 10am-1am Sun: 10am-11pm",
                "subsectionName": "Sliders",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "139 Montague St",
                    "formatted": "139 Montague St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.694863,
                    "lon": -73.993711
                },
                "itemId": "8861876644798123621",
                "menuItemName": "Half Tray Beef, Buffalo Chicken or Turkey Sliders (35 Pieces)",
                "menuItemDescription": "Beef, Buffalo Chicken or Turkey Sliders w/ French Fries or House Salad",
                "price": 95,
                "restaurant_id": 4069486373993711,
                "restaurantName": "The Custom House",
                "restaurant_phone": "(718) 643-6000",
                "hours": "Mon-Wed: 11am-11pm Thu-Fri: 11am-1am Sat: 10am-1am Sun: 10am-11pm",
                "subsectionName": "Catering & Party Orders",
                "subsectionDescription": "Selection of Items available in Full & Half Tray Sizes. Items MUST Be Ordered a Mimimum 24 HOURS Prior to required time.",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "139 Montague St",
                    "formatted": "139 Montague St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.694863,
                    "lon": -73.993711
                },
                "itemId": "1670588810482649355",
                "menuItemName": "Buffalo Chicken Flatbread",
                "menuItemDescription": "Served with Monterrey Jack and blue cheese.",
                "price": 15.95,
                "restaurant_id": 4069486373993711,
                "restaurantName": "The Custom House",
                "restaurant_phone": "(718) 643-6000",
                "hours": "Mon-Wed: 11am-11pm Thu-Fri: 11am-1am Sat: 10am-1am Sun: 10am-11pm",
                "subsectionName": "Homemade Flatbreads",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "139 Montague St",
                    "formatted": "139 Montague St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.694863,
                    "lon": -73.993711
                },
                "itemId": "16294204922862820543",
                "menuItemName": "Buffalo Chicken Wrap",
                "menuItemDescription": "Grilled chicken tossed in Buffalo sauce with blue cheese crumbles. Served with fries or salad.",
                "price": 15.95,
                "restaurant_id": 4069486373993711,
                "restaurantName": "The Custom House",
                "restaurant_phone": "(718) 643-6000",
                "hours": "Mon-Wed: 11am-11pm Thu-Fri: 11am-1am Sat: 10am-1am Sun: 10am-11pm",
                "subsectionName": "Sandwiches",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "27 Smith St",
                    "formatted": "27 Smith St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.690698,
                    "lon": -73.987621
                },
                "itemId": "2967329743113853753",
                "menuItemName": "Buffalo Chicken Wings",
                "menuItemDescription": "Six.",
                "price": 5,
                "restaurant_id": 4069069873987621,
                "restaurantName": "Saporita Pizza",
                "restaurant_phone": "(718) 643-7777",
                "hours": "Sun-Fri: 10:30am-6pm",
                "subsectionName": "Appetizers",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "208 Livingston St",
                    "formatted": "208 Livingston St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.689591,
                    "lon": -73.986004
                },
                "itemId": "1821196258875194833",
                "menuItemName": "Buffalo Chicken Pizza",
                "menuItemDescription": "",
                "price": 20,
                "restaurant_id": 4068959173986004,
                "restaurantName": "Bella Pizza",
                "restaurant_phone": "(718) 522-4100",
                "hours": "",
                "subsectionName": "Pizza",
                "subsectionDescription": "",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "51B Willoughby St",
                    "formatted": "51B Willoughby St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.692364,
                    "lon": -73.987015
                },
                "itemId": "10611117097418067173",
                "menuItemName": "Buffalo Chicken Cold Cut",
                "menuItemDescription": "",
                "price": 4.99,
                "restaurant_id": 4069236473987015,
                "restaurantName": "Willoughby Food Bar",
                "restaurant_phone": "(718) 855-8447",
                "hours": "",
                "subsectionName": "Cold Cut Sandwich",
                "subsectionDescription": "Choice of roll, hero or wrap.",
                "menus": []
            }, {
                "address": {
                    "city": "Brooklyn",
                    "state": "NY",
                    "zip": "11201",
                    "streetAddress": "233 Schermerhorn St",
                    "formatted": "233 Schermerhorn St Brooklyn, NY 11201"
                },
                "geo": {
                    "lat": 40.688497,
                    "lon": -73.984774
                },
                "itemId": "5385522409268219362",
                "menuItemName": "B11. Morning Glory Sandwich",
                "menuItemDescription": "Buffalo chicken, egg white, Swiss, spinach with avocado on a wrap.",
                "price": 6.5,
                "restaurant_id": 4068849773984774,
                "restaurantName": "Metro Finest Deli",
                "restaurant_phone": "(347) 721-3711",
                "hours": "",
                "subsectionName": "Breakfast Signature Sandwiches",
                "subsectionDescription": "",
                "menus": []
            }],
            "numResults": 25
        }
    }
}

